module.exports = __webpack_public_path__ + "static/paczki-e85caeeca68cf62fed48d7dafb143d71.jpg";